import React, { useLayoutEffect, useState } from "react";
import GridLGHidden from "../components/GridComponent/components/GridLGHidden";
import Header from "../components/Header/Header";
import GridComponent from "../components/GridComponent/GridComponent";
import { LeftSideComponent } from "../components/Sidebar/Sidebar";
import GridTitle from "../components/GridComponent/components/GridTitle";
import { useNavigate } from "react-router-dom";
import Typography from "../components/Typography/Typography";
import UserIcon from "../assets/icons/bx-user.svg";
import UserIconBlue from "../assets/icons/bx-user-blue.svg";
import OrganizationICon from "../assets/icons/bx-group.svg";
import OrganizationIConBlue from "../assets/icons/bx-group-blue.svg";
import CardIcon from "../assets/icons/bx-credit-card.svg";
import CardIconBlue from "../assets/icons/bx-credit-card-blue.svg";
import Divider from "../components/Divider/Divider";
import LogOutIcon from "../assets/icons/bx-log-out-red.svg";
import BottomNav from "../components/BottomNav/BottomNav";
import GridSMHidden from "../components/GridComponent/components/GridSMHidden";
import { useQueryClient } from "@tanstack/react-query";
import Loading from "../components/Loading/Loading";

export const openCookiebotPreferences = () => {
  if (typeof window !== "undefined" && window.Cookiebot) {
    try {
      if (typeof window.Cookiebot.renew === "function") {
        // Fallback to renew
        window.Cookiebot.renew();
      } else if (typeof window.Cookiebot.show === "function") {
        window.Cookiebot.show();
      }
    } catch (e) {
      console.error("Error opening Cookiebot dialog:", e);
      // Last resort: try renew
      window.Cookiebot?.renew?.();
    }
  }
};

const Account = () => {
  const [loading, setLoading] = useState(false);

  useLayoutEffect(() => {
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    metaThemeColor && metaThemeColor.setAttribute("content", "#F5F5FC");
  }, []);

  return (
    <div className="flex flex-col lg:flex-row bg-[#F5F5FC] lg:bg-transparent h-svh">
      <GridLGHidden>
        <Header backgroundColor="[#F5F5FC]" />
      </GridLGHidden>
      {loading && <Loading />}
      <GridComponent
        leftSideComponent={<LeftSideComponent />}
        containerClassNames={"lg:grid-cols-grid-chat-no-right-lg"}
        mainComponent={<MainComponent setLoading={setLoading} />}
        //  mainComponentContainerClassNames="max-w-[1083px]"
      />
      <GridLGHidden>
        <BottomNav />
      </GridLGHidden>
    </div>
  );
};

export default Account;

const MainComponent = ({
  setLoading,
}: {
  setLoading: (val: boolean) => void;
}) => {
  const [hovered, setHovered] = useState<
    "account" | "organization" | "billing" | "logout" | "billing" | null
  >(null);
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return (
    <div className="flex flex-1 flex-col">
      <GridSMHidden>
        <GridTitle title="Account" />
      </GridSMHidden>
      <div className="lg:bg-white rounded-20 lg:p-24 ">
        <Typography type="Header3">Account Settings</Typography>
        <div className="rounded-2xl border bg-white lg:bg-transparent border-light-grey-10 p-16 mt-24">
          <div
            className="flex gap-20 items-center cursor-pointer group"
            onClick={() => navigate("/account-details")}
            onMouseEnter={() => setHovered("account")}
            onMouseLeave={() => setHovered(null)}
          >
            <img src={hovered === "account" ? UserIconBlue : UserIcon} alt="" />
            <div>
              <Typography
                type="Body"
                typeSM="Body2"
                className="group-hover:text-[#2E3BC7]"
              >
                Account
              </Typography>
              <Typography
                type="Body3"
                className="text-dark-grey-5 group-hover:text-[#5862D2]"
              >
                Manage your account details.
              </Typography>
            </div>
          </div>
          <Divider marginY="my-16" />
          <div
            className="flex gap-20 items-center cursor-pointer group"
            onClick={() => navigate("/organization-details")}
            onMouseEnter={() => setHovered("organization")}
            onMouseLeave={() => setHovered(null)}
          >
            <img
              src={
                hovered === "organization"
                  ? OrganizationIConBlue
                  : OrganizationICon
              }
              alt=""
            />
            <div>
              <Typography
                type="Body"
                typeSM="Body2"
                className="group-hover:text-[#2E3BC7]"
              >
                Organization
              </Typography>
              <Typography
                type="Body3"
                className="text-dark-grey-5 group-hover:text-[#5862D2]"
              >
                Manage your organization details.
              </Typography>
            </div>
          </div>
        </div>
        <div className="rounded-2xl border bg-white lg:bg-transparent border-light-grey-10 p-16 mt-24">
          <div
            className="flex gap-20 items-center cursor-pointer group"
            onClick={() => navigate("/billing")}
            onMouseEnter={() => setHovered("billing")}
            onMouseLeave={() => setHovered(null)}
          >
            <img src={hovered === "billing" ? CardIconBlue : CardIcon} alt="" />
            <div>
              <Typography
                type="Body"
                typeSM="Body2"
                className="group-hover:text-[#2E3BC7]"
              >
                Billing
              </Typography>
              <Typography
                type="Body3"
                className="text-dark-grey-5 group-hover:text-[#5862D2]"
              >
                Manage your subscriptions.
              </Typography>
            </div>
          </div>
          <Divider marginY="my-16" />
          <div
            className="flex gap-20 items-center cursor-pointer group"
            onClick={() => {
              window.localStorage.removeItem("accessToken");
              window.localStorage.removeItem("refreshToken");
              window.localStorage.removeItem("calendlyPrefillName");
              window.localStorage.removeItem("calendlyPrefillEmail");
              queryClient.removeQueries();
              setLoading(true);
              setTimeout(() => {
                setLoading(false);
                navigate("/login");
              }, 1000);
            }}
          >
            <img src={LogOutIcon} alt="" />
            <div>
              <Typography
                type="Body"
                typeSM="Body2"
                className="!text-[#EA2D71]"
              >
                Log out
              </Typography>
              <Typography
                type="Body3"
                className="text-dark-grey-5 group-hover:text-[#EA2D71]"
              >
                Log out from this profile.
              </Typography>
            </div>
          </div>
        </div>
      </div>
      <div className={"mt-36 flex-col text-center lg:pb-24"}>
        <a
          href={"https://talkpal.ai/privacy-policy/"}
          target={"_blank"}
          rel="noopener noreferrer"
        >
          <Typography
            type={"Body4"}
            className={"text-dark-grey-5 lg:hover:text-[#282828]"}
          >
            Privacy Policy
          </Typography>
        </a>
        <a
          href={"https://talkpal.ai/terms-and-conditions/"}
          target={"_blank"}
          rel="noopener noreferrer"
        >
          <Typography
            type={"Body4"}
            className={"text-dark-grey-5 lg:hover:text-[#282828]"}
          >
            Terms And Conditions
          </Typography>
        </a>
        <a
          href={"https://talkpal.ai/data-processing-agreement/"}
          target={"_blank"}
          rel="noopener noreferrer"
        >
          <Typography
            type={"Body4"}
            className={"text-dark-grey-5 lg:hover:text-[#282828]"}
          >
            Data Processing Agreement
          </Typography>
        </a>
        <a
          href={"https://talkpal.ai/end-user-license-agreement/"}
          target={"_blank"}
          rel="noopener noreferrer"
        >
          <Typography
            type={"Body4"}
            className={"text-dark-grey-5 lg:hover:text-[#282828]"}
          >
            End User License Agreement
          </Typography>
        </a>
        <div onClick={openCookiebotPreferences} className={"cursor-pointer"}>
          <Typography
            type={"Body4"}
            className={"text-dark-grey-5 lg:hover:text-[#282828]"}
          >
            Cookie Preferences
          </Typography>
        </div>
        <a
          href={"https://talkpal.ai/do-not-sell-share-my-personal-information/"}
          target={"_blank"}
          rel="noopener noreferrer"
        >
          <Typography
            type={"Body4"}
            className={"text-dark-grey-5 lg:hover:text-[#282828]"}
          >
            Do not sell/share my personal information
          </Typography>
        </a>
        <Typography type={"Body4"} className={"mt-10 text-dark-grey-5"}>
          Customer support:{" "}
          <a
            className="underline underline-offset-2 lg:hover:text-[#282828CC]"
            href={"mailto: business@talkpal.ai"}
            type={"mailto"}
            target={"_blank"}
            rel={"noreferrer"}
          >
            business@talkpal.ai
          </a>
        </Typography>
      </div>
    </div>
  );
};
